//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AnimationDesigner.js";
import "../no/Builder.js";
import "../no/SelectNXObject.js";
import "../Mechatronics/Mechatronics.FrameBuilderList.js";
import "../no/Expression.js";
import "../no/Mechatronics.js";
import "../no/ugmath.js";
import "../no/Expression.js";
import "../no/SelectObject.js";
import "../no/ObjectList.js";
let d=[[[0,"AlignType",1,0],[0,"AvoidCollision",1,0],[0,"BodyType",1,0],[0,"EulerAngleConvention",1,0],[0,"FirstPoint",1,"Point",0],[1,"FirstRigidGroup",0,"SelectNXObject",0],[1,"FrameList",0,"Mechatronics.FrameBuilderList",0],[0,"GenerateTracer",1,0],[0,"Name",1,0],[1,"PointTolerance",0,"Expression",0],[1,"RigidGroup",0,"SelectNXObject",0],[0,"SecondPoint",1,"Point",0],[1,"SecondRigidGroup",0,"SelectNXObject",0],[0,"StartPoint",1,"Point",0],[0,"TargetPoint",1,"Point",1],[1,"VectorTolerance",0,"Expression",0]],[[["startOrit","targetOrit"],"SetOrientation",{},2,1],[["startOrit"],"SetStartPointOrientation",{},1,0],[["startOrit","targetOrit"],"GetOrientation",{},0,1],[[],"GetStartPointOrientation",{R_:{startOrit:''}},0,0],[["startOrit"],"SetFirstPointOrientation",{},1,0],[[],"GetFirstPointOrientation",{R_:{startOrit:''}},0,0],[["startOrit"],"SetSecondPointOrientation",{},1,0],[[],"GetSecondPointOrientation",{R_:{startOrit:''}},0,0],[[],"GetResult",{R_:{result:''}},0,0],[[],"GetErrorPose",{R_:{pose:"CoordinateSystem"}},0,0],[[],"UpdateIk",{},0,0],[[],"UpdateIkStatus",{},0,0]],[]];
SPLM.AnimationDesigner.InverseKinematicsBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AnimationDesigner.InverseKinematicsBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.AnimationDesigner.InverseKinematicsBuilder.BodyTypes = Object.freeze({
    "OneBody" : "OneBody", "TwoBodies" : "TwoBodies"});

SPLM.AnimationDesigner.InverseKinematicsBuilder.AlignTypes = Object.freeze({
    "All" : "All", "Z" : "Z", "Y" : "Y", "X" : "X", "None" : "None"});

SPLM.AnimationDesigner.InverseKinematicsBuilder.Result = Object.freeze({
    "Success" : "Success", "NotSolved" : "NotSolved", "Approximate" : "Approximate", "Limits" : "Limits", "ReachError" : "ReachError", "Timeout" : "Timeout", "CollisionTarget" : "CollisionTarget", "CollisionStart" : "CollisionStart", "Limit" : "Limit", "TargetEqualsStart" : "TargetEqualsStart", "Unknown" : "Unknown"});

export default SPLM;